/**
 * Protocol Buffer Helper for Web Client
 * 
 * This module provides utilities for working with Busable Protocol Buffers.
 * Adapted from @busable/functions/src/lib/proto-helper.js for web client use.
 */

// Import the proto library (using require for CommonJS compatibility)
const busableProto = require('@busable/busable-proto');

/**
 * Decode an operator to protobuf
 * @param {Buffer|Uint8Array} buffer - Protobuf buffer to decode
 * @returns {object} Decoded operator object
 */
export function decodeOperator(buffer) {
  const Operator = busableProto.busable.Operator;
  return Operator.decode(buffer);
}

/**
 * Decode a route variant to protobuf
 * @param {Buffer|Uint8Array} buffer - Protobuf buffer to decode
 * @returns {object} Decoded route object
 */
export function decodeRoute(buffer) {
  const Route = busableProto.busable.Route;
  return Route.decode(buffer);
}

/**
 * Decode a schedule to protobuf
 * @param {Buffer|Uint8Array} buffer - Protobuf buffer to decode
 * @returns {object} Decoded schedule object
 */
export function decodeSchedule(buffer) {
  const Schedule = busableProto.busable.Schedule;
  return Schedule.decode(buffer);
}

/**
 * Decode a shiftBat to protobuf
 * @param {Buffer|Uint8Array} buffer - Protobuf buffer to decode
 * @returns {object} Decoded shiftBat object
 */
export function decodeShiftBat(buffer) {
  const ShiftBat = busableProto.busable.ShiftBat;
  return ShiftBat.decode(buffer);
}

/**
 * Decode a stop to protobuf
 * @param {Buffer|Uint8Array} buffer - Protobuf buffer to decode
 * @returns {object} Decoded stop object
 */
export function decodeStop(buffer) {
  const Stop = busableProto.busable.Stop;
  return Stop.decode(buffer);
}
